// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itaassetspg-inline-1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.itaassetspg-inline-2 {
  font-size: 18px;
  font-weight: 700;
}

.itaassetspg-inline-3 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.itaassetspg-inline-4 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 12px;
}

.itaassetspg-inline-5 {
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
}

.itaassetspg-inline-6 {
  padding: 0;
  overflow-x: auto;
}

.itaassetspg-inline-7 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
  font-size: 13px;
}

.itaassetspg-inline-8 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
  font-size: 13px;
}

.itaassetspg-inline-9 {
  font-family: monospace;
  font-size: 11px;
}

.itaassetspg-inline-10 {
  font-weight: 600;
}

.itaassetspg-inline-11 {
  font-size: 11px;
  color: #94a3b8;
}

.itaassetspg-inline-12 {
  color: #94a3b8;
}

.itaassetspg-inline-13 {
  font-size: 11px;
}

.itaassetspg-inline-14 {
  font-size: 11px;
}

.itaassetspg-inline-15 {
  display: flex;
  gap: 6px;
}

.itaassetspg-inline-16 {
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #4f46e5;
  cursor: pointer;
}

.itaassetspg-inline-17 {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #ef4444;
  cursor: pointer;
}

.itaassetspg-inline-18 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.itaassetspg-inline-19 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.itaassetspg-inline-20 {
  margin-top: 16px;
}

.itaassetspg-inline-21 {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  padding: 10px 14px;
  margin-bottom: 14px;
}

.itaassetspg-inline-22 {
  font-size: 13px;
  font-weight: 700;
}

.itaassetspg-inline-23 {
  font-size: 11px;
  color: #94a3b8;
}

.itaassetspg-inline-24 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.itaassetspg-inline-25 {
  margin-top: 16px;
}

.itaassetspg-dyn-1 {
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: var(--itaassetspg-1-border);
  background: var(--itaassetspg-1-background);
  color: var(--itaassetspg-1-color);
}

.itaassetspg-dyn-2 {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  background: var(--itaassetspg-2-background);
  color: var(--itaassetspg-2-color);
}

.itaassetspg-dyn-3 {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  background: var(--itaassetspg-3-background);
  color: var(--itaassetspg-3-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ITAdmin/ITAAssetsPg.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC","sourcesContent":[".itaassetspg-inline-1 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.itaassetspg-inline-2 {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.itaassetspg-inline-3 {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.itaassetspg-inline-4 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2563eb;\n  margin-bottom: 12px;\n}\n\n.itaassetspg-inline-5 {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.itaassetspg-inline-6 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.itaassetspg-inline-7 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.itaassetspg-inline-8 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.itaassetspg-inline-9 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.itaassetspg-inline-10 {\n  font-weight: 600;\n}\n\n.itaassetspg-inline-11 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.itaassetspg-inline-12 {\n  color: #94a3b8;\n}\n\n.itaassetspg-inline-13 {\n  font-size: 11px;\n}\n\n.itaassetspg-inline-14 {\n  font-size: 11px;\n}\n\n.itaassetspg-inline-15 {\n  display: flex;\n  gap: 6px;\n}\n\n.itaassetspg-inline-16 {\n  background: #eef2ff;\n  border: 1px solid #c7d2fe;\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #4f46e5;\n  cursor: pointer;\n}\n\n.itaassetspg-inline-17 {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #ef4444;\n  cursor: pointer;\n}\n\n.itaassetspg-inline-18 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.itaassetspg-inline-19 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.itaassetspg-inline-20 {\n  margin-top: 16px;\n}\n\n.itaassetspg-inline-21 {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 9px;\n  padding: 10px 14px;\n  margin-bottom: 14px;\n}\n\n.itaassetspg-inline-22 {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.itaassetspg-inline-23 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.itaassetspg-inline-24 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.itaassetspg-inline-25 {\n  margin-top: 16px;\n}\n\n.itaassetspg-dyn-1 {\n  padding: 5px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  border: var(--itaassetspg-1-border);\n  background: var(--itaassetspg-1-background);\n  color: var(--itaassetspg-1-color);\n}\n\n.itaassetspg-dyn-2 {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  background: var(--itaassetspg-2-background);\n  color: var(--itaassetspg-2-color);\n}\n\n.itaassetspg-dyn-3 {\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 700;\n  background: var(--itaassetspg-3-background);\n  color: var(--itaassetspg-3-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
